import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AppLayout from '../../components/AppLayout/AppLayout';
import { useAppData } from '../../context/AppDataContext';

export default function HomePage() {
  const { refresh, loading, error, lastSyncedAt } = useAppData();

  return (
    <AppLayout>
      <Box component="header" sx={{ my: { xs: 8, sm: 17 }, maxWidth: '42rem' }}>
        <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
          Сайн байна уу.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Таны ажлын орчин бэлэн — ном, контентоо эндээс удирдаарай
        </Typography>
        <Stack direction="column" spacing={1.5} sx={{ mt: 4 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => void refresh()}
            disabled={loading}
            sx={{ alignSelf: 'flex-start' }}
          >
            {loading ? 'Шинэчилж байна…' : 'Системийн дата дахин шинэчлэх'}
          </Button>
          {lastSyncedAt ? (
            <Typography variant="caption" color="text.secondary">
              Сүүлд шинэчилсэн: {new Date(lastSyncedAt).toLocaleString('mn-MN')}
            </Typography>
          ) : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </Box>
    </AppLayout>
  );
}
